import React from 'react';
import { InfoIcon, Text, Tooltip } from '@beef/ui-kit';
import { getLocalCurrencyStr } from '@beef/utils';
import classNames from 'classnames/bind';
import { formatDate } from "../../../../utils";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Price = function Price(_ref) {
  var className = _ref.className,
    fee = _ref.fee,
    feePeriod = _ref.feePeriod,
    feeTooltip = _ref.feeTooltip,
    isPromo = _ref.isPromo,
    isPromoExpired = _ref.isPromoExpired,
    nextFee = _ref.nextFee,
    promoExpiryDate = _ref.promoExpiryDate;
  var withPromoExpiryDate = Boolean(isPromo && promoExpiryDate);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('price', className),
    "data-t-id": "components-Price"
  }, feePeriod && !withPromoExpiryDate && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    size: "size2-m"
  }, getLocalCurrencyStr(fee === null || fee === void 0 ? void 0 : fee.value)), !isPromoExpired && (!!nextFee || nextFee === 0) && /*#__PURE__*/React.createElement(Text, {
    className: cn('old'),
    color: "grey60",
    crossOutColor: "magenta",
    isCrossedOut: true,
    size: "size5-r-s"
  }, getLocalCurrencyStr(nextFee)), /*#__PURE__*/React.createElement(Text, {
    className: cn('period'),
    color: "grey60",
    size: "size5-r-s"
  }, feePeriod)), withPromoExpiryDate && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    className: cn('zero'),
    size: "size2-m"
  }, getLocalCurrencyStr(0)), /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-r-s"
  }, "\u0434\u043E \xA0", formatDate(promoExpiryDate))), feeTooltip && /*#__PURE__*/React.createElement("div", {
    className: "mar-l-3xs"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    message: feeTooltip,
    position: "top"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: cn('icon'),
    fill: "#727281",
    size: 18,
    "data-t-id": "components-Price"
  }))));
};